module.exports = __webpack_public_path__ + "static/media/coinexLight.d649399b.png";